var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
import { Component, Vue, Watch, Ref } from "vue-facing-decorator";
import { ReportScheduleModel, ReportClient, GetReportScheduleListQuery, SortDescription, SortDirection, ReportSchedulePeriodEnum } from "@/app/api/battery-portal-api";
import { HttpHelper } from "@/app/utils/http-helper";
import { DateHelper } from "@/app/utils/date-helper";
import { Notifier } from "@/common/utils/notifier";
import Sorter from "@/common/utils/sorter";
import ReportSchedulerWizardVue from "@/app/vues/reports/report-scheduler-wizard.vue";
import ReportScheduleedLogVue from "@/app/vues/reports/report-scheduled-log.vue";
const reportClient = new ReportClient(window.apiUrl);
let ReportManagerVue = class ReportManagerVue extends Vue {
    constructor() {
        super(...arguments);
        this.reportId = -1;
        // singleton
        this.working = false;
        this.loaded = false;
        this.showModal = false;
        this.showLog = false;
        this.includeDeleted = false;
        this.records = new Array();
        this.selectedModel = new ReportScheduleModel();
        this.sorter = new Sorter(new SortDescription({
            fieldName: "reportName",
            direction: SortDirection.Ascending
        }));
    }
    show(reportId, canSchedule) {
        this.reportId = reportId;
        this.showModal = true;
        this.canSchedule = canSchedule;
        this.getScheduledReports();
    }
    getScheduledReports() {
        this.working = true;
        var query = new GetReportScheduleListQuery({
            reportId: this.reportId,
            includeDeleted: this.includeDeleted,
            sort: this.sorter.currentSort
        });
        reportClient.getScheduledReportList(query).then((response) => {
            this.records = response;
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
            this.loaded = true;
        });
    }
    onSortChanged() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.getScheduledReports();
        });
    }
    ;
    edit(item) {
        this.reportSchedulerWizard.show(item, this.canSchedule);
    }
    editFilters(item) {
        this.$emit('editScheduledReportFilter', item);
        this.showModal = false;
    }
    archive(item) {
        if (this.working)
            return;
        this.$confirmModal.show("Are you sure that you want to archive this scheduled report?", { title: "Please confirm" })
            .then((value) => {
            if (!value)
                return;
            this.working = true;
            reportClient
                .deleteScheduledReport(item.id)
                .then(() => {
                item.whenDeleted = new Date();
                this.$emit('updateCount', this.reportId, -1);
                Notifier.onOk(`Report Scheduled # ${item.id} has been successfully archived.`);
            })
                .catch((ex) => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        });
    }
    restore(item) {
        if (this.working)
            return;
        this.working = true;
        reportClient
            .restoreScheduledReport(item.id)
            .then(() => {
            item.whenDeleted = undefined;
            this.$emit('updateCount', this.reportId, 1);
            Notifier.onOk(`Scheduled report # ${item.id} has been successfully restored.`);
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    viewHistory(item) {
        this.selectedModel = item;
        this.showLog = true;
    }
    //Computed
    get noData() {
        return this.loaded && (!this.records || !this.records.length);
    }
    ;
    getDateTime(date) {
        return DateHelper.convertToFriendlyMomentTimeString(date);
    }
    ;
    getPeriodDescription(period) {
        switch (period) {
            case ReportSchedulePeriodEnum.Once: return "Once";
            case ReportSchedulePeriodEnum.Daily: return "Daily";
            case ReportSchedulePeriodEnum.Weekely: return "Weekly";
            case ReportSchedulePeriodEnum.Monthly: return "Monthly";
        }
        ;
        return "";
    }
};
__decorate([
    Ref("reportSchedulerWizard"),
    __metadata("design:type", Object)
], ReportManagerVue.prototype, "reportSchedulerWizard", void 0);
__decorate([
    Watch("sorter.currentSort"),
    Watch("includeDeleted"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", typeof (_a = typeof Promise !== "undefined" && Promise) === "function" ? _a : Object)
], ReportManagerVue.prototype, "onSortChanged", null);
ReportManagerVue = __decorate([
    Component({
        name: "ReportSchedulerManagerVue",
        expose: ["show"],
        emits: ["editScheduledReportFilter", "updateCount"],
        components: {
            ReportSchedulerWizardVue,
            ReportScheduleedLogVue
        }
    })
], ReportManagerVue);
export default ReportManagerVue;
